import styled from "styled-components"
import ColorPick from "../molecules/ColorPick"
import mixins from "../../../styles/mixins"
import { useCheckByte } from "../../common/hook"

const Wrap = styled.section`
    > .h2 {
        margin-bottom: 4px;
    }

    > .row-wrap {
        margin-top: 8px;
    }

    .desc.tip {
        margin-top: 3px;
    }

    display: flex;
    gap: 0 28px;

    .text-cont {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1 1;

        .skin-tone-code {
            display: flex;
            align-items: center;
            background-color: #f7f7f7;
            border-radius: 5px;
            padding: 4px 8px;
            margin-left: 13px;
            font-size: 14px;
            font-weight: 700;
            line-height: 22.4px;

            .color-view {
                width: 12px;
                height: 12px;
                border-radius: 100%;
                margin-right: 5px;
            }
        }

        p:not(.info) {
            height: 100px;
            ${mixins.clampTextLine(6)}
            font-size: 11.5px !important;
        }
    }
}

.badge {
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 10px;
    font-weight: 400;
    line-height: ${(14 / 10)};
    margin-top: 8px;
    width: fit-content;

    &.normal {
        color: #0979ff;
        background-color: #e0f4ff;
    }
    &.low {
        color: #848484;
        background-color: #eeeeee;
    }
    &.high {
        color: #f3645c;
        background-color: #fff0f0;
    }
}
}

// 특성
.characteristic-list {
flex: 1 1;
gap: 0;

section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1 1;
    padding: 14px 20px;
    border-radius: 0;
    gap: 20px 0;

    &:first-child {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }
    &:last-child {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    & ~ section {
        position: relative;
        &::before {
            content: "";
            display: block;
            width: 1px;
            height: 158px;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            background-color: rgba(238, 238, 238, 1);
        }
    }
    .progress-chart-wrap {
        margin-top: 20px;
    }
    .text-cont {
        width: 100%;
        align-items: center;
        justify-content: space-between;
    }
}
}

// 피부 타입, 나이
.skin-type-wrap {
width: 110px;

> section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1 1;
    padding: 14px 11px;

    p.caption {
        font-size: 10px;
        line-height: ${(14 / 10)};
        color: rgba(28, 195, 145, 1);
        margin-top: 3px;
    }

    > .info {
        margin-top: 10px;
    }
`
export default function SkinTone({data}) {
    return (
        <Wrap>
            <div className="text-cont">
                <div className="row-wrap">
                    <div className="h1">{data.tone}</div>

                    <div className="skin-tone-code">
                        <div className="color-view" style={{ background: data.skinColor }}></div>
                        {data.skinColor}
                    </div>
                </div>

                <p className="body3">
                {
                data.description.split(/\n/).map((el,idx) => {
                    if (idx == 0) {
                        return <>{el}</>
                    } else {
                        return <><br/>{el}</>
                    }
                })
                }
                </p>
                <p className="desc info">해상도에 따라서 피부색이 달라보일 수 있습니다.</p>
            </div>

            <div className="img-cont">
                <ColorPick skinColor={data.skinColor} colorCode={data.colorCode} />
            </div>
        </Wrap>
    )
}